module.exports = __webpack_public_path__ + "static/media/2.8079404a.jpg";